import { render } from "./DarkBar.vue?vue&type=template&id=14a84a08&scoped=true&ts=true"
import script from "./DarkBar.vue?vue&type=script&lang=ts"
export * from "./DarkBar.vue?vue&type=script&lang=ts"

import "./DarkBar.vue?vue&type=style&index=0&id=14a84a08&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a84a08"]])

export default __exports__